var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthenticatorApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33594 6.66732H6.67169V3.33398H3.33594V6.66732ZM8.33956 16.6673H11.6753V13.334H8.33956V16.6673ZM3.33594 16.6673H6.67169V13.334H3.33594V16.6673ZM3.33594 11.6673H6.67169V8.33398H3.33594V11.6673ZM8.33956 11.6673H11.6753V8.33398H8.33956V11.6673ZM13.3432 3.33398V6.66732H16.6789V3.33398H13.3432ZM8.33956 6.66732H11.6753V3.33398H8.33956V6.66732ZM13.3432 11.6673H16.6789V8.33398H13.3432V11.6673ZM13.3432 16.6673H16.6789V13.334H13.3432V16.6673Z",
    fill: "#4B475C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticatorApp);
export default __webpack_public_path__ + "static/media/authenticator_app.0617f5ff7613f2eab8074516e701def9.svg";
export { ForwardRef as ReactComponent };